import office from 'src/services/office';
import { OperationsLogger } from 'src/services/runtime/operationsLog';

import * as Flowstep from '@v2/services/runtime/flowstepExecution';
import { isEmpty } from 'shared/utils/flow';
import * as ConvertIds from 'src/services/convertIdsExecution';
import * as Flow from 'src/services/flowExecution';

import { officeStore } from 'src/stores';


const Button = {
  Cancel: { key: 'cancel', text: 'No' },
  Run: { key: 'run', text: 'Yes', primary: true },
};


const Data = {
  buttons: [Button.Cancel, Button.Run],
};


export async function executeFlowsteps(flowsteps, cancelToken) {
  return await executeRunnables(flowsteps, Flowstep.execute, cancelToken);
}

export async function executeFlows(flows, cancelToken, options = {}) {
  const { requestStore } = officeStore;
  const { withoutDialogs = false, selectedRanges } = options;
  const isSingleFlow = flows.length === 1;
  flows = flows.filter(x => !isEmpty(x));
  if (!flows.length) {
    requestStore.warn(isSingleFlow ? `The flow does not contain any steps to execute` : `No flow contains steps to execute`);
    return;
  }

  const text = flows.length > 1
    ? 'This will run all flows defined in your entire workbook. Are you sure?'
    : `This will run all flow steps that are part of flow '${flows[0].name}', it may contain operations in multiple worksheets. Are you sure?`

  const key = withoutDialogs ? Button.Run.key : await requestStore.showDialog(text, Data.buttons);
  if (key === Button.Run.key) {
    await executeRunnables(flows, (flows, meta) => Flow.execute(flows, { ...meta, selectedRanges }), cancelToken);
  }
}

export async function convertIds(selection, cancelToken) {
  return await executeRunnables(selection, ConvertIds.execute, cancelToken);
}


async function executeRunnables(runnables, executor, cancelToken) {
  const { requestStore, userStore } = officeStore;

  await Excel.run(async (context) => {
    requestStore.setText(`Setting calculation mode to 'Manual'`, { withSpinner: true });
    const calculationMode = await office.getCalculationMode();
    console.log(`Setting calculation mode to 'Manual'. Original mode is '${calculationMode}'`);
    await office.setCalculationMode(Excel.CalculationMode.manual);

    let logger = null;

    try {
      requestStore.setText(`Opening log`, { withSpinner: true });
      logger = userStore.settings?.enableManualOperationsLog
        ? await OperationsLogger.open(context.workbook)
        : null;
      const meta = { context, logger, officeStore, cancelToken, timezone: userStore.settings?.timezone };

      await executor?.(runnables, meta);
    }
    finally {
      requestStore.setText(`Closing log`, { withSpinner: true });
      logger && await logger.close();

      requestStore.setText(`Restoring original calculation mode`, { withSpinner: true });
      console.log(`Restoring original calculation mode '${calculationMode}'`);
      await office.setCalculationMode(calculationMode);
    }
  });
}